import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useIsRequesterView = () => {
  const { pathname } = useLocation();

  const isRequesterView = useMemo(
    () => pathname.includes('/ticketing/portal'),
    [pathname]
  );

  return isRequesterView;
};
